<template>
    <div>
        <span>{{ message }}</span>
    </div>
</template>

<script>
import { maskVisitorDisplayNameIfNeeded } from "../../../../utils/utils";
import _ from "lodash";

export default {
    name: "ChatDataDownloaded",
    props: {
        activity: {
            type: Object,
            required: true
        }
    },
    computed: {
        message() {
            const visitorName = this.$_.get(this.activity, 'payload.visitorName');
            const chatCount = this.$_.get(this.activity, 'payload.chatCount', 0);
            
            if (visitorName) {
                return this.$t('notification.chatDataDownloadedWithVisitor', {
                    actor: this.$_.get(this.activity, 'actorUser.name'),
                    visitorName: maskVisitorDisplayNameIfNeeded(visitorName, _.get(this.activity, "refVisitor"))
                });
            }
            
            return this.$t('notification.chatDataDownloaded', {
                actor: this.$_.get(this.activity, 'actorUser.name'),
                chatCount: chatCount
            });
        }
    }
};
</script>

